import { Navigate, useLocation } from 'react-router-dom'
import { useAppContext } from '../hooks/AppContextProvider'

interface RoleMiddlewareProps {
  children: React.ReactNode
  allowedRoles: ('user' | 'tenant' | 'masterTenant')[]
}

const RoleMiddleware = ({ children, allowedRoles }: RoleMiddlewareProps) => {
  const location = useLocation()
  const { isTenant, isMaster } = useAppContext()

  if (isMaster) {
    return <>{children}</>
  }

  if (isTenant) {
    const isAllowed = allowedRoles.includes('tenant')
    if (!isAllowed) {
      if (location.pathname === '/not-found') {
        return <>{children}</>
      }
      return <Navigate to="/not-found" replace />
    }
    return <>{children}</>
  }

  const isAllowed = allowedRoles.includes('user')
  if (!isAllowed) {
    if (location.pathname === '/not-found') {
      return <>{children}</>
    }
    return <Navigate to="/not-found" replace />
  }

  return <>{children}</>
}

export default RoleMiddleware 